import React, { useState } from "react";
import { ChoiceList, FormLayout, Modal, Select } from "@shopify/polaris";
import type { CostAdjustment } from "../../../api_utils/types";

const COST_ITEMS = [
  "Custom duties",
  "Discount",
  "Foreign transaction fee",
  "Freight fee",
  "Insurance",
  "Other",
  "Rush fee",
  "Shipping",
  "Surcharge",
  "Tax",
];

export default function AddCostAdjustmentModal({
  onAdd,
  onClose,
}: {
  readonly onAdd: (costAdjustment: Pick<CostAdjustment, "label" | "amount_type">) => void;
  readonly onClose: () => void;
}): React.JSX.Element {
  const [label, setLabel] = useState("Tax");
  const [amountType, setAmountType] = useState<CostAdjustment["amount_type"]>("fixed");

  return (
    <Modal
      onClose={onClose}
      open
      primaryAction={{
        content: "Add adjustment",
        onAction: () => {
          onAdd({ label, amount_type: amountType });
        },
      }}
      secondaryActions={[{ content: "Cancel", onAction: onClose }]}
      title="Add adjustment"
    >
      <Modal.Section>
        <FormLayout>
          <Select label="Adjustment type" onChange={setLabel} options={COST_ITEMS} value={label} />
          <ChoiceList
            choices={[
              { label: "Dollar amount", value: "fixed" },
              { label: "Percentage", value: "percentage" },
            ]}
            onChange={([value]) => {
              setAmountType(value as CostAdjustment["amount_type"]);
            }}
            selected={[amountType]}
            title="Amount type"
          />
        </FormLayout>
      </Modal.Section>
    </Modal>
  );
}
